<template>
    <div style="margin: 0; padding: 0">
        <Wifi v-if="name === 'Wifi'" :color="color" />
        <Back v-else-if="name === 'Back'" :color="color" />
        <Light v-else-if="name === 'Light'" :color="color" />
        <Whells v-else-if="name === 'Whells'" :color="color" />
        <Dart v-else-if="name === 'Dart'" :color="color" />
        <Arrow v-else-if="name === 'Arrow'" :color="color" />
        <Pdf v-else-if="name === 'PDF'" :color="color" />
        <Triangle v-else-if="name === 'Triangle'" :color="color" />
        <FullTime v-else-if="name === 'FullTime'" :color="color" />
        <ManTime v-else-if="name === 'ManTime'" :color="color" />
    </div>
</template>
<script>
import Wifi from "../svg/fastWizard/Wifi.vue";
import Back from "../svg/fastWizard/Back.vue";
import Light from "../svg/fastWizard/Light.vue";
import Whells from "../svg/fastWizard/Whells.vue";
import Dart from "../svg/fastWizard/Dart.vue";
import Arrow from "../svg/fastWizard/Arrow.vue";
import Pdf from "../svg/fastWizard/Pdf.vue";
import Triangle from "../svg/fastWizard/Triangle.vue";
import FullTime from "../svg/fastWizard/FullTime.vue";
import ManTime from "../svg/fastWizard/ManTime.vue";

export default {
    name: "DynamicSvg",
    props: ["name", "color"],
    components: { ManTime, FullTime, Triangle, Arrow, Dart, Whells, Light, Back, Wifi, Pdf },
};
</script>
